"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createUseStyles;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactJss = require("react-jss");

var _jss = require("./jss");

var _uuid = _interopRequireDefault(require("../utils/uuid"));

function createUseStyles(styles) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _reactJss.createUseStyles)(styles, (0, _defineProperty2.default)({
    theming: _jss.theming
  }, _jss.RAMBLER_UI_DISPLAY_NAME_PREFIX, "".concat(options.name || (0, _uuid.default)(), "-")));
}